import React, { useState } from 'react';
import PropTypes from 'prop-types';
import phrasesType from '../../proptypes/phrases';
import InviteModal from './InviteModal';

const InviteFriends = ({
  referralUrl,
  phrases,
  onCopy,
  onShare,
  onMainButtonClick,
  ...props
}) => {
  const [modalVisible, showModal] = useState(false);

  const openModal = () => {
    showModal(true);
    onMainButtonClick();
  };

  const closeModal = () => showModal(false);

  return (
    <div {...props}>
      <InviteModal
        referralUrl={referralUrl}
        modalVisible={modalVisible}
        onClose={closeModal}
        phrases={phrases}
        onCopy={onCopy}
        onShare={onShare}
      />
      <button
        type="button"
        className="btn btn-primary"
        onClick={openModal}
      >
        {phrases.inviteFriends.referralInviteButtonTitle}
      </button>
    </div>
  );
};

InviteFriends.defaultProps = {
  onCopy: () => undefined,
  onMainButtonClick: () => undefined,
  onShare: () => undefined,
};

InviteFriends.propTypes = {
  onCopy: PropTypes.func,
  onMainButtonClick: PropTypes.func,
  onShare: PropTypes.func,
  phrases: phrasesType.isRequired,
  referralUrl: PropTypes.string.isRequired,
};

export default InviteFriends;
